import {
  SUBMIT_MANUAL_BOOKING_APPROVAL,
  SUBMIT_MANUAL_BOOKING_APPROVAL_SUCCESS,
  SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR,
  SUBMIT_MANUAL_BOOKING_APPROVAL_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const SubmitManualBookingApproval = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_MANUAL_BOOKING_APPROVAL:
      return { ...state, loading: true, data: null, error: null };
    case SUBMIT_MANUAL_BOOKING_APPROVAL_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR:
      return { ...state, loading: false, error: action.payload };
    case SUBMIT_MANUAL_BOOKING_APPROVAL_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default SubmitManualBookingApproval;
